import { Instance } from 'mobx-state-tree'
import { TeachingTableModelBase } from './TeachingTableModel.base'

/* The TypeScript type of an instance of TeachingTableModel */
export interface TeachingTableModelType extends Instance<typeof TeachingTableModel.Type> {}

/* A graphql query fragment builders for TeachingTableModel */
export {
  selectFromTeachingTable,
  teachingTableModelPrimitives,
  TeachingTableModelSelector
} from './TeachingTableModel.base'

/**
 * TeachingTableModel
 */
export const TeachingTableModel = TeachingTableModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
